import React, { useEffect, useState } from "react";
import SntSearch from "@/components/ReactBootstrap/SntSearch";

interface FilterValue {
  search: string;
}

interface SimpleFilterListData {
  filter?: {
    search?: string;
  };
}

interface SimpleFilterListProps {
  onChange?: (data: FilterValue) => void;
  data?: SimpleFilterListData;
  multiMode?: boolean;
  searchPlaceholder?: string;
}

const SimpleFilterList: React.FC<SimpleFilterListProps> = ({
  onChange,
  data,
  multiMode,
  searchPlaceholder = "Search here…",
}) => {
  const [filterValue, setFilterValue] = useState<FilterValue>({
    search: data && data.filter ? data.filter.search || "" : "",
  });

  useEffect(() => {
    const timeOutId = setTimeout(() => onChange?.(filterValue), 500);
    return () => clearTimeout(timeOutId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterValue]);

  return (
    <>
      {data && data.filter && data.filter.search !== undefined && (
        <SntSearch
          className="mb-2"
          placeholder={searchPlaceholder}
          value={filterValue.search}
          onChange={(value: string) =>
            setFilterValue({ ...filterValue, search: value })
          }
        />
      )}
    </>
  );
};

export default SimpleFilterList;
